import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SettingsMenu from './SettingsMenu'; // Import the SettingsMenu
import WabaProfile from './WabaProfile';
import ContactColumn from './ContactColumn';
import CommonMessage from './CommonMessage';

const Settings = ({ currentUser }) => {
console.log(currentUser);
  return (
    <div className="settings-container">
      <div className="settings-header">
        <h1>Settings</h1>
        <SettingsMenu /> {/* Render the Settings Menu */}
      </div>

      {/* Routing to render components based on selected menu item */}
      <div className="settings-content">
        <Routes>
          <Route path="waba-profile" element={<WabaProfile currenUser={currentUser}/>} />
          <Route path="contact-column" element={<ContactColumn currentUser={currentUser}/>} />
          <Route path="common-message" element={<CommonMessage />} />
        </Routes>
      </div>
    </div>
  );
};

export default Settings;
